/* eslint-disable react-hooks-ext/exhaustive-deps -- TODO(react-hooks): 2 hook(s) need dependency review; fix each and remove this directive */
/* eslint no-loop-func: 0 */

import { Divider, Popover } from "@mui/material";
import MenuComponent from "@CubeComponents/html/MenuComponent";
import MenuItemComponent from "@CubeComponents/html/MenuItemComponent";
import NestedMenuItem from "@CubeComponents/html/NestedMenuItem";
import { useEffect, useRef, useState, forwardRef, useContext, useId, useImperativeHandle, useCallback } from "react";
import ColorPickerComponent from "@CubeComponents/Mui_Form/ColorPickerComponent";
import IsolateZoomHelper from "./IsolateZoomHelper.js";
import { setModalStatus, updateTransparentElements, setViewerState } from "@Reducers/Viewer";
import { useDispatch, useSelector } from "react-redux";
import { getAllLeafNodesRecur, CubeGlobal } from "../HCViewerUtils.js";
import _ from "lodash";
import useViewerCallbacks from "../useViewerCallbacks.jsx";
import { useTranslation, untranslated } from "@i18n";
import { RootState } from "@Reducers/index";
import { RC_MENU_ITEMS, streamingModeMap } from "@Helpers/constants.js";
import { HoopsViewerContext } from "../ViewerContext";
import { getIsViewerDependencyLoaded } from "@Services/utils/helpers.js";
import { dispatchModelLoadingToast } from "@Actions/Viewer.js";
import { showToastNotification } from "@Reducers/toastSlice";
import { TOAST_TYPE_WARNING } from "@Services/constants.js";
import Text from "@CubeComponents/html/Text/Text.js";
import {
  Color,
  Selection,
  PickConfig,
  SelectionMask,
  NodeType,
  ElementType,
  OperatorId,
  KeyModifiers,
} from "@ts3d-hoops/web-viewer";
import IconComponent from "@CubeComponents/icons/index.js";
const HoopsRightClickContextMenu = forwardRef(
  ({ HoopsModalStatus, modelTreeNodeId, isOpenedThrough3DModel = true }: any, ref) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const {
      GetSettingModalData: settingsData,
      transparentElements,
      viewerState,
    } = useSelector((state: RootState) => state);
    const menuId = useId();
    const [menuPosition, setMenuPosition] = useState<{ top: number; left: number } | null>(null);
    const [disabledItemIds, setDisabledItemIds] = useState<Set<string>>(new Set());

    const openMenu = useCallback((top: number, left: number) => {
      setMenuPosition({ top, left });
    }, []);

    const closeMenu = useCallback(() => {
      setMenuPosition(null);
    }, []);

    const enableMenuItems = useCallback((ids: string[], enabled: boolean) => {
      setDisabledItemIds((prev) => {
        const next = new Set(prev);
        for (const id of ids) {
          if (enabled) next.delete(id);
          else next.add(id);
        }
        return next;
      });
    }, []);

    useImperativeHandle(ref, () => ({
      open: openMenu,
      enableItems: enableMenuItems,
    }));
    const [selectedNodeId, setSelectedNodeId] = useState<any>(null);
    const isolateZoomHelper: any = useRef<any>(null);
    CubeGlobal.isolateZoomHelper = isolateZoomHelper;
    const [showColorPicker, setShowColorPicker] = useState(false);
    const [colorPickerPosition, setColorPickerPosition] = useState<{ top: number; left: number } | null>(null);
    const [rightClickPosition, setRightClickPosition] = useState(0);
    const colorPickerRef: any = useRef<any>(null);
    const { viewerImpl, isModelStructureReady, isSettingsApplied } = useContext(HoopsViewerContext);
    const loadedNodesRef = useRef(new Set());

    const selectionItems = ["Isolate", "Focus", "Hide", "Override"];
    const streamingMode = settingsData.ModelLoading_progressiveLoading;
    const hoopsCallback = {
      contextMenu(position: any) {
        if (
          !getIsViewerDependencyLoaded({ isModelStructureReady, isSettingsApplied, viewerImpl, hwv: CubeGlobal.hwv })
        ) {
          dispatch(dispatchModelLoadingToast);
          return;
        }
        setRightClickPosition(position);
        const canvasEl = document.getElementById("viewerContainer");
        const rect = canvasEl?.getBoundingClientRect();
        const offsetX = rect?.left ?? 0;
        const offsetY = rect?.top ?? 0;
        openMenu(position.y + offsetY, position.x + offsetX);
      },
    };

    const viewerCallbacks = isOpenedThrough3DModel ? hoopsCallback : null;

    useViewerCallbacks({
      viewerCallbacks,
      triggerRerender: isOpenedThrough3DModel,
    });

    useEffect(() => {
      if (
        getIsViewerDependencyLoaded({ isModelStructureReady, isSettingsApplied, viewerImpl, hwv: CubeGlobal.hwv }) &&
        viewerImpl?.hwv
      ) {
        const selItems = viewerImpl?.hwv.selectionManager.getResults();
        enableItems(selItems.length);
      }
    }, [rightClickPosition, isModelStructureReady, isSettingsApplied]);
    const toggle = () => {
      if (menuPosition) {
        setColorPickerPosition({ top: menuPosition.top, left: menuPosition.left });
      }
      setShowColorPicker(true);
    };

    const [nodeColor, setnodeColor] = useState("#0000FF");

    const compColorChange = function (color: any) {
      setnodeColor(color.value);
    };

    const hexToRgb = (hex: any) => {
      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result
        ? new Color(Number.parseInt(result[1]!, 16), Number.parseInt(result[2]!, 16), Number.parseInt(result[3]!, 16))
        : null;
    };

    const shouldIncludeNode = (nodeId: any, rootId: any, includeRoot: boolean): boolean => {
      return includeRoot || nodeId !== rootId;
    };

    const isValidLoadedNode = (nodeId: any, model: any, rootId: any, includeRoot: boolean): boolean => {
      return model.isNodeLoaded(nodeId) && shouldIncludeNode(nodeId, rootId, includeRoot);
    };

    const getSelectedItemIds = (selectionManager: any, model: any, rootId: any, includeRoot: boolean): any[] => {
      const selectedItems = selectionManager.getResults();
      const itemIds: any[] = [];

      for (const item of selectedItems) {
        const id = item.getNodeId();
        if (isValidLoadedNode(id, model, rootId, includeRoot)) {
          itemIds.push(id);
        }
      }

      return itemIds;
    };

    const shouldAddClickedNode = (
      nodeId: any,
      rootId: any,
      includeRoot: boolean,
      itemIds: any[],
      selectionManager: any,
    ): boolean => {
      if (!shouldIncludeNode(nodeId, rootId, includeRoot)) {
        return false;
      }

      if (includeRoot) {
        return true;
      }

      if (itemIds.length === 0) {
        return true;
      }

      const selectionItem = Selection.SelectionItem.create(nodeId);
      const containsParent = selectionManager.containsParent(selectionItem) !== null;
      const containsItem = itemIds.includes(nodeId);

      return !containsItem && !containsParent;
    };

    const processClickedNode = (
      nodeId: any,
      includeClicked: boolean,
      rootId: any,
      includeRoot: boolean,
      itemIds: any[],
      selectionManager: any,
    ): void => {
      if (nodeId === null || !includeClicked) {
        return;
      }

      if (shouldAddClickedNode(nodeId, rootId, includeRoot, itemIds, selectionManager)) {
        itemIds.push(nodeId);
      }
    };

    const getContextItemIds = (nodeId: any, includeSelected: any, includeClicked: any, includeRoot = true) => {
      if (
        !getIsViewerDependencyLoaded({ viewerImpl, hwv: CubeGlobal.hwv, isModelStructureReady, isSettingsApplied }) ||
        !viewerImpl?.hwv
      ) {
        return [];
      }

      const hwvInstance = viewerImpl.hwv;
      const { selectionManager } = hwvInstance;
      const { model } = hwvInstance;
      const rootId = model.getAbsoluteRootNode();

      let itemIds: any[] = [];

      if (includeSelected) {
        itemIds = getSelectedItemIds(selectionManager, model, rootId, includeRoot);
      }

      processClickedNode(nodeId, includeClicked, rootId, includeRoot, itemIds, selectionManager);

      return itemIds;
    };

    const getModelNodeId = async (position: any) => {
      if (viewerImpl?.hwv) {
        let nodeId = null;
        let positino3d = null;

        if (!position) return { nodeId, positino3d };

        const config = new PickConfig(SelectionMask.All);
        const selectionItem = await viewerImpl?.hwv.view.pickFromPoint(position, config);
        const axisOverlay = 1;

        let nodeType;
        if (selectionItem.isNodeSelection()) {
          nodeType = viewerImpl?.hwv.model.getNodeType(selectionItem.getNodeId());
        }

        if (
          nodeType === undefined ||
          nodeType === NodeType.Pmi ||
          nodeType === NodeType.PmiBody ||
          selectionItem.overlayIndex() === axisOverlay
        ) {
          return { nodeId, positino3d };
        }

        nodeId = selectionItem.getNodeId();
        positino3d = selectionItem.getPosition();

        return { nodeId, positino3d };
      }
    };

    const isAllIfcSpace = (nodeIds: any) => {
      if (viewerImpl?.hwv) {
        return nodeIds.every((nodeId: any) => viewerImpl?.hwv.model.hasEffectiveGenericType(nodeId, "IfcSpace"));
      }
      return false;
    };

    const isolateFunc = async (nodeId: any) => {
      const nodeIds = getContextItemIds(nodeId, true, true);
      await isolateNodes(nodeIds);
    };

    const isolateNodes = async (nodeIds: any) => {
      await isolateZoomHelper.current?.isolateNodes(nodeIds, isAllIfcSpace(nodeIds)! ? false : null);
    };

    CubeGlobal.isolateNodes = isolateNodes;

    const zoomFunc = async (nodeId: any) => {
      const nodeIds = getContextItemIds(nodeId, true, true);
      if (nodeIds?.length == 0) return;
      await isolateZoomHelper.current?.fitNodes(nodeIds);
    };

    CubeGlobal.zoomFunc = zoomFunc;

    const transparentFunc = async (nodeId: any) => {
      const contextItemIds = getContextItemIds(nodeId, true, true);
      if (contextItemIds?.length == 0) return;
      const leafNodes: any = [];

      for (const item of contextItemIds) {
        getAllLeafNodesRecur(item, leafNodes);
      }

      if (!viewerImpl?.hwv) {
        return;
      }

      const opacityOfFirstItem = (await viewerImpl.hwv.model.getNodesOpacity([leafNodes[0]]))[0];

      const tempElement = new Set(transparentElements);

      if (opacityOfFirstItem === null || opacityOfFirstItem === 1) {
        viewerImpl?.hwv.model.setNodesOpacity(leafNodes, 1 - Number(settingsData.General_transparency));
        for (const node of leafNodes) tempElement.add(node);
      } else {
        viewerImpl?.hwv.model.resetNodesOpacity(leafNodes);
        for (const node of leafNodes) tempElement.delete(node);
      }
      dispatch(updateTransparentElements(Array.from(tempElement)));
    };

    const showAllFunc = async () => {
      await isolateZoomHelper.current.showAll();
    };

    const _isColorSet = async (contextItemIds: any) => {
      const activeColor = hexToRgb(nodeColor);
      let colorSet = true;

      for (const contextItemId of contextItemIds) {
        const colorMap = await viewerImpl?.hwv.model.getNodeColorMap(contextItemId, ElementType.Faces);
        if (colorMap.size === 0) {
          return false;
        }
        for (const color of colorMap.values()) {
          if (!color.equals(activeColor)) {
            colorSet = false;
          }
        }
      }

      return colorSet;
    };

    const setColorFunc = async (nodeId: any, nodeColor: any) => {
      const contextItemIds = getContextItemIds(nodeId, true, true, false);
      if (contextItemIds.length > 0) {
        if (await _isColorSet(contextItemIds)) {
          viewerImpl?.hwv.model.unsetNodesFaceColor(contextItemIds);
        } else {
          const baseColor = Color.black();
          const color: any = hexToRgb(nodeColor);
          baseColor.r = color.r;
          baseColor.g = color.g;
          baseColor.b = color.b;
          viewerImpl?.hwv.model.setNodesFaceColor(contextItemIds, baseColor);
        }
      }
    };

    CubeGlobal.setColorFunc = setColorFunc;

    const resetFunc = async () => {
      const handleOperator = viewerImpl?.hwv.operatorManager.getOperator(OperatorId.Handle);
      await handleOperator.removeHandles();
      await viewerImpl?.hwv.model.reset();
      viewerImpl?.hwv.model.unsetNodesFaceColor([viewerImpl?.hwv.model.getAbsoluteRootNode()]);
      dispatch(updateTransparentElements([]));
    };

    const handlesFunc = async (nodeId: any, position: any) => {
      const modifiers = KeyModifiers.None;
      const handleOperator = viewerImpl?.hwv.operatorManager.getOperator(OperatorId.Handle);
      const contextItemIds = getContextItemIds(nodeId, true, true, false);
      if (contextItemIds.length > 0) {
        try {
          await handleOperator.addHandles(contextItemIds, (modifiers as any) === KeyModifiers.Shift ? null : position);
        } catch (e: unknown) {
          if (
            (e as Error).message == "Handles are not enabled when the model is exploded" ||
            (e as Error).message == "Handles are not enabled while a measurement is in progress."
          ) {
            dispatch(
              showToastNotification({
                content: untranslated((e as Error).message),
                type: TOAST_TYPE_WARNING,
              }),
            );
          } else {
            throw e;
          }
        }
      }
    };

    const scaleHandleFunction = async (nodeId: any) => {
      const scaleHandleOperator = viewerImpl?.hwv.view.operatorManager.getOperator(
        CubeGlobal.OperatorId.ScaleHandlesOperatorID,
      );
      const contextItemIds = getContextItemIds(nodeId, true, true, false);
      if (contextItemIds.length <= 0) return;
      scaleHandleOperator.show(contextItemIds[0]);
    };

    const _isItemVisible = async (nodeId: any) => {
      if (nodeId === null) {
        const selectionItems = viewerImpl?.hwv.selectionManager.getResults();
        if (selectionItems.length === 0) {
          return false;
        }
        nodeId = selectionItems[0].getNodeId();
      }

      return viewerImpl?.hwv.model.getNodeVisibility(nodeId);
    };

    const _isMenuItemVisible = async (nodeId: any) => _isItemVisible(nodeId);

    const visibilityFunc = async (nodeId: any) => {
      const visible = await _isMenuItemVisible(nodeId);
      const nodeIds = getContextItemIds(nodeId, true, true);
      await viewerImpl?.hwv.model.setNodesVisibility(nodeIds, !visible, isAllIfcSpace(nodeIds)! ? false : null);
      viewerImpl?.hwv.selectionManager.clear();
    };

    const onDemandLoad = async (modelTreeNodeId: any) => {
      await viewerImpl?.hwv.model.requestNodes([modelTreeNodeId]);
      loadedNodesRef.current.add(modelTreeNodeId);
    };

    const getFileNode = (nodeId: any) => {
      if (!nodeId) return;

      const absoluteRoot = viewerImpl?.hwv.model.getAbsoluteRootNode();
      let rootNode = null;
      let currentNode = nodeId;
      let parent = nodeId;

      while (rootNode == null) {
        parent = viewerImpl?.hwv.model.getNodeParent(currentNode);
        if (parent == null) break;
        if (parent == absoluteRoot) {
          rootNode = currentNode;
          break;
        }
        currentNode = parent;
      }

      return rootNode;
    };

    const selectFileFunc = (nodeId: any) => {
      if (!nodeId) return;

      const fileNode = getFileNode(nodeId);

      if (fileNode != null) {
        viewerImpl?.hwv.selectionManager.clear();
        viewerImpl?.hwv.selectionManager.selectNode(fileNode);
      }
    };

    useEffect(() => {
      if (viewerImpl?.hwv) {
        isolateZoomHelper.current = new IsolateZoomHelper(viewerImpl?.hwv);
      }
    }, [viewerImpl]);

    const allMenuItems = [
      {
        id: RC_MENU_ITEMS.ISOLATE,
        text: t("Isolate"),
        iconName: "Isolate",
      },
      {
        id: RC_MENU_ITEMS.FOCUS,
        text: t("Focus"),
        iconName: "Highlight",
      },
      {
        id: RC_MENU_ITEMS.HIDE,
        text: t("Hide"),
        iconName: "EyeClose",
      },
      {
        id: RC_MENU_ITEMS.ON_DEMAND_LOAD,
        text: t("Load Node"),
      },
      {
        separator: true,
      },
      {
        id: RC_MENU_ITEMS.OVERRIDE,
        text: t("Override"),
        iconName: "Override",
        items: [
          {
            id: RC_MENU_ITEMS.TRANSFORM,
            text: t("Transform"),
            iconName: "Transform",
          },
          {
            id: RC_MENU_ITEMS.SCALE,
            text: t("Scale"),
            iconName: "Scale",
          },
          {
            id: RC_MENU_ITEMS.SET_COLOR,
            text: t("Set Color"),
            iconName: "SetColor",
          },
          {
            id: RC_MENU_ITEMS.MODIFY_COLOR,
            text: t("Modify Color"),
            iconName: "modifyColor",
          },
          {
            id: RC_MENU_ITEMS.TRANSPARENCY,
            text: t("Transparency"),
            iconName: "Transparency",
          },
        ],
      },
      {
        id: RC_MENU_ITEMS.SELECTION,
        text: t("Selection"),
        iconName: "Selection",
        items: [
          {
            id: RC_MENU_ITEMS.FILE,
            text: t("File"),
            iconName: "files",
          },
          {
            separator: true,
          },
          {
            id: RC_MENU_ITEMS.ELEMENT,
            text: t("Element"),
            iconName: viewerState.selectionMode == "element" ? "Highlight" : "",
          },
          {
            id: RC_MENU_ITEMS.PARENT,
            text: t("Parent"),
            iconName: viewerState.selectionMode == "parent" ? "Highlight" : "",
          },
          {
            id: RC_MENU_ITEMS.GRAND_PARENT,
            text: t("GrandParent"),
            iconName: viewerState.selectionMode == "grandParent" ? "Highlight" : "",
          },
        ],
      },
      {
        id: RC_MENU_ITEMS.SHOW_ALL,
        text: t("Show All"),
        iconName: "ShowAll",
      },
      {
        id: RC_MENU_ITEMS.PROPERTIES,
        text: t("Properties"),
        iconName: "Properties_icon",
      },
      {
        id: RC_MENU_ITEMS.RESET,
        text: t("Reset"),
        iconName: "Reset_icon",
      },
    ];
    const removeLoadNode = (arr: any) => arr.filter((item: any) => item.id !== RC_MENU_ITEMS.ON_DEMAND_LOAD);

    const menuItems = streamingMode === streamingModeMap.OnDemand ? allMenuItems : removeLoadNode(allMenuItems);

    const handleMenuItemClick = (item: any) => {
      onSelect({ item });
      closeMenu();
    };

    const VIEWER_DEPENDENT_ITEMS = new Set<string>([
      RC_MENU_ITEMS.ISOLATE,
      RC_MENU_ITEMS.FOCUS,
      RC_MENU_ITEMS.HIDE,
      RC_MENU_ITEMS.ON_DEMAND_LOAD,
      RC_MENU_ITEMS.TRANSFORM,
      RC_MENU_ITEMS.SCALE,
      RC_MENU_ITEMS.SET_COLOR,
      RC_MENU_ITEMS.TRANSPARENCY,
      RC_MENU_ITEMS.RESET,
      RC_MENU_ITEMS.PROPERTIES,
      RC_MENU_ITEMS.SHOW_ALL,
      RC_MENU_ITEMS.FILE,
    ]);

    const onSelect = async (args: any) => {
      const nodeId = selectedNodeId;

      if (
        VIEWER_DEPENDENT_ITEMS.has(args.item.id) &&
        !getIsViewerDependencyLoaded({ isModelStructureReady, isSettingsApplied, viewerImpl, hwv: CubeGlobal.hwv })
      ) {
        dispatch(dispatchModelLoadingToast);
        return;
      }

      switch (args.item.id) {
        case RC_MENU_ITEMS.ISOLATE:
          isolateFunc(nodeId);
          break;
        case RC_MENU_ITEMS.FOCUS:
          zoomFunc(nodeId);
          break;
        case RC_MENU_ITEMS.HIDE:
          visibilityFunc(nodeId);
          break;
        case RC_MENU_ITEMS.ON_DEMAND_LOAD:
          await onDemandLoad(modelTreeNodeId);
          break;
        case RC_MENU_ITEMS.TRANSFORM:
          handlesFunc(nodeId, null);
          break;
        case RC_MENU_ITEMS.SCALE:
          scaleHandleFunction(nodeId);
          break;
        case RC_MENU_ITEMS.SET_COLOR:
          setColorFunc(nodeId, nodeColor);
          break;
        case RC_MENU_ITEMS.MODIFY_COLOR:
          toggle();
          break;
        case RC_MENU_ITEMS.TRANSPARENCY:
          transparentFunc(nodeId);
          break;
        case RC_MENU_ITEMS.RESET:
          resetFunc();
          break;
        case RC_MENU_ITEMS.PROPERTIES: {
          const selection = viewerImpl?.hwv.selectionManager.getResults();
          if (nodeId && selection.length == 0) {
            viewerImpl?.hwv.selectionManager.selectNode(nodeId);
          }
          dispatch(
            setModalStatus({
              ...HoopsModalStatus,
              Metadata: {
                show: true,
              },
            }),
          );
          break;
        }
        case RC_MENU_ITEMS.SHOW_ALL:
          showAllFunc();
          break;
        case RC_MENU_ITEMS.FILE:
          selectFileFunc(nodeId);
          break;
        case RC_MENU_ITEMS.ELEMENT:
          dispatch(setViewerState({ selectionMode: "element" }));
          break;
        case RC_MENU_ITEMS.PARENT:
          dispatch(setViewerState({ selectionMode: "parent" }));
          break;
        case RC_MENU_ITEMS.GRAND_PARENT:
          dispatch(setViewerState({ selectionMode: "grandParent" }));
          break;
        default:
          break;
      }
    };

    const getAllMenuIds = (items: any) =>
      items.flatMap((item: any) =>
        item.separator ? [] : [...(item.id ? [item.id] : []), ...(item.items ? getAllMenuIds(item.items) : [])],
      );

    const enableItems = (enable: any, nodeId?: any, isNodeLoaded?: boolean) => {
      const allMenuIds = getAllMenuIds(allMenuItems);

      if (_.get(HoopsModalStatus, "ModelCompare.show")) {
        enableMenuItems(allMenuIds, false);
        return;
      }

      if (streamingMode === streamingModeMap.OnDemand && nodeId !== undefined) {
        handleOnDemandMode(allMenuIds, isNodeLoaded);
      } else {
        enableMenuItems(enable ? allMenuIds : selectionItems, enable);
      }
      enableMenuItems(["Properties"], !HoopsModalStatus?.Metadata?.show);
    };

    const handleOnDemandMode = (allMenuIds: string[], isNodeLoaded?: boolean) => {
      const nodeLoaded = isNodeLoaded ?? loadedNodesRef.current.has(modelTreeNodeId);
      enableMenuItems(allMenuIds, false);

      if (nodeLoaded) {
        const itemsToEnable = allMenuIds.filter((id: string) => id !== RC_MENU_ITEMS.ON_DEMAND_LOAD);
        enableMenuItems(itemsToEnable, true);
      } else {
        enableMenuItems([RC_MENU_ITEMS.ON_DEMAND_LOAD], true);
      }
    };

    const beforeOpenEvent = async () => {
      if (
        getIsViewerDependencyLoaded({ isModelStructureReady, isSettingsApplied, viewerImpl, hwv: CubeGlobal.hwv }) &&
        viewerImpl?.hwv
      ) {
        const selectedNodeIdObject = await getModelNodeId(rightClickPosition);
        const nodeId = selectedNodeIdObject!.nodeId;
        const selItem = Selection.SelectionItem.create(nodeId);
        const selResults = viewerImpl?.hwv.selectionManager.getResults();
        selResults.push(selItem);
        viewerImpl?.hwv?.selectionManager.set(selResults);
        setSelectedNodeId(nodeId);

        if (streamingMode === streamingModeMap.OnDemand) {
          const isNodeLoaded = loadedNodesRef.current.has(modelTreeNodeId);
          enableItems(true, nodeId, isNodeLoaded);
        } else {
          enableItems(true);
        }
      } else {
        dispatch(dispatchModelLoadingToast);
      }
    };

    useEffect(() => {
      if (menuPosition) {
        beforeOpenEvent();
        const suppressBrowserMenu = (e: MouseEvent) => e.preventDefault();
        document.addEventListener("contextmenu", suppressBrowserMenu, true);
        return () => document.removeEventListener("contextmenu", suppressBrowserMenu, true);
      }
    }, [menuPosition]);

    const beforeCloseColorPicker = () => {
      setShowColorPicker(false);
    };

    const renderMenuItem = (item: any) => {
      if (item.separator) {
        return <Divider key={`sep-${Math.random()}`} />;
      }
      const icon = <IconComponent name={item.iconName} width="1rem" height="1rem" />;
      if (item.items) {
        return (
          <NestedMenuItem
            key={item.id}
            label={item.text}
            icon={icon}
            disabled={disabledItemIds.has(item.id)}
            parentMenuOpen={!!menuPosition}
          >
            {item.items.map((subItem: any) => renderMenuItem(subItem))}
          </NestedMenuItem>
        );
      }
      return (
        <MenuItemComponent
          key={item.id}
          disabled={disabledItemIds.has(item.id)}
          onClick={() => handleMenuItemClick(item)}
        >
          {icon && <span style={{ display: "flex", alignItems: "center", width: "1.25rem" }}>{icon}</span>}
          {item.text}
        </MenuItemComponent>
      );
    };

    return (
      <Text>
        <Popover
          open={showColorPicker}
          onClose={beforeCloseColorPicker}
          anchorReference="anchorPosition"
          anchorPosition={colorPickerPosition ?? undefined}
          anchorOrigin={{ vertical: "top", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
        >
          <ColorPickerComponent
            beforeClose={beforeCloseColorPicker}
            ref={colorPickerRef}
            id="comp-model-picker-2"
            enableOpacity={false}
            value={nodeColor}
            change={compColorChange}
          />
        </Popover>
        <div>
          <MenuComponent
            data-testid="rightClickMenuItems"
            id={`contextmenu_${menuId}`}
            open={!!menuPosition}
            onClose={closeMenu}
            anchorReference="anchorPosition"
            anchorPosition={menuPosition || undefined}
          >
            {menuItems.map((item: any) => renderMenuItem(item))}
          </MenuComponent>
        </div>
      </Text>
    );
  },
);
HoopsRightClickContextMenu.displayName = "HoopsRightClickContextMenu";
export default HoopsRightClickContextMenu;
